import { useEffect, useRef } from 'react';

export function usePollingWhile(condition, callback) {
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!condition) return;

    const poll = () => {
      callback();
    };

    intervalRef.current = setInterval(poll, 10000);
    timeoutRef.current = setTimeout(() => {
      clearInterval(intervalRef.current);
    }, 5 * 60 * 1000);

    poll();

    return () => {
      clearInterval(intervalRef.current);
      clearTimeout(timeoutRef.current);
    };
  }, [condition, callback]);
}